<template>
  <div class="live-publish-plan-run">
    <!-- 顶部信息 -->
    <div class="header-bar">
      <el-button icon="el-icon-arrow-left" @click="goBack" style="margin-right: 12px">返回计划列表</el-button>
      <span v-if="groupName" style="font-size: 16px; font-weight: bold">
        执行记录：{{ groupName }}
      </span>
      <span v-if="groupId" style="color: #909399; margin-left: 12px">({{ groupId }})</span>
      <el-button icon="el-icon-refresh" @click="loadRuns" style="margin-left: auto">刷新</el-button>
    </div>

    <!-- 执行批次表格 -->
    <el-table
      :data="runList"
      border
      stripe
      v-loading="loading"
      style="width: 100%; margin-top: 12px"
      :empty-text="'暂无执行记录'"
      @row-click="openEvents"
    >
      <el-table-column prop="runId" label="批次ID" min-width="200" show-overflow-tooltip />
      <el-table-column prop="triggerSource" label="触发来源" width="130" align="center" />
      <el-table-column prop="status" label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag size="small" :type="runStatusType(scope.row.status)">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="排队/跳过" width="100" align="center">
        <template slot-scope="scope">
          <span>排队 {{ scope.row.queuedCount || 0 }} / 跳过 {{ scope.row.skippedCount || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开始时间" width="160" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.startTime || '—' }}</template>
      </el-table-column>
      <el-table-column label="结束时间" width="160" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.endTime || '—' }}</template>
      </el-table-column>
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click.stop="openEvents(scope.row)">明细</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-if="runTotal > pageSize"
      @current-change="handleRunPage"
      :current-page="runPage"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="runTotal"
      style="margin-top: 16px; text-align: right"
    />

    <!-- 事件明细对话框 -->
    <el-dialog
      title="执行事件明细"
      :visible.sync="eventsVisible"
      width="750px"
      :close-on-click-modal="false"
    >
      <p v-if="currentRunId" style="color: #909399; margin-bottom: 12px">批次: {{ currentRunId }}</p>

      <el-table :data="eventList" border stripe v-loading="eventsLoading" max-height="400">
        <el-table-column prop="planId" label="计划ID" width="200" show-overflow-tooltip />
        <el-table-column prop="accountId" label="账号ID" width="90" />
        <el-table-column prop="accountName" label="账号名称" min-width="100" />
        <el-table-column prop="eventType" label="事件类型" width="80" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="eventTypeTag(scope.row.eventType)">{{ scope.row.eventType }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="eventCode" label="事件码" width="130" show-overflow-tooltip />
        <el-table-column prop="eventMessage" label="事件详情" min-width="150" show-overflow-tooltip />
        <el-table-column label="时间" width="160" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.createTime || '—' }}</template>
        </el-table-column>
      </el-table>

      <div slot="footer">
        <el-button @click="eventsVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/axios";
import message from "@/utils/message";

const API_BASE = window.location.protocol + "//" + window.location.host + "/trc20/qdd/api/livePublish";

export default {
  name: "LivePublishPlanRun",
  data() {
    return {
      loading: false,
      eventsLoading: false,

      groupId: "",
      groupName: "",

      runList: [],
      runTotal: 0,
      runPage: 1,
      pageSize: 10,

      eventsVisible: false,
      currentRunId: "",
      eventList: [],
    };
  },

  mounted() {
    this.groupId = this.$route.query.groupId || "";
    this.groupName = this.$route.query.groupName || "";
    if (this.groupId) this.loadRuns();
  },

  methods: {
    loadRuns() {
      this.loading = true;
      request.post({
        url: API_BASE + "/plan/run/list",
        data: { groupId: this.groupId || undefined, pageIndex: this.runPage, pageSize: this.pageSize },
        success: (res) => {
          this.loading = false;
          if (res.code === 0) {
            this.runList = res.data || [];
            this.runTotal = this.runList.length;
          } else {
            message.error(res.msg || "加载失败");
          }
        },
        error: () => { this.loading = false; message.error("请求失败"); },
      });
    },

    openEvents(row) {
      this.currentRunId = row.runId;
      this.eventsVisible = true;
      this.eventsLoading = true;
      request.post({
        url: API_BASE + "/plan/run/events",
        data: { runId: row.runId },
        success: (res) => {
          this.eventsLoading = false;
          if (res.code === 0) {
            this.eventList = res.data || [];
          } else {
            message.error(res.msg || "加载事件失败");
          }
        },
        error: () => { this.eventsLoading = false; message.error("请求失败"); },
      });
    },

    handleRunPage(page) {
      this.runPage = page;
      this.loadRuns();
    },

    goBack() {
      this.$router.push({ path: this.feUrl + "/livePublishPlan.html" });
    },

    runStatusType(s) {
      return { finished: "success", running: "primary", failed: "danger" }[s] || "info";
    },

    eventTypeTag(t) {
      return { success: "success", failed: "danger", skipped: "warning", running: "primary" }[t] || "info";
    },
  },
};
</script>

<style scoped>
.live-publish-plan-run { padding: 16px; }
.header-bar { display: flex; align-items: center; }
</style>
